import { COLOR, SPACING } from 'app-v2/design-tokens'
import { media } from 'app/assets/styles'
import { Link } from 'app/common/link'
import { fonts, SmallText, styleSmallText } from 'app/common/typography'
import { Field } from 'formik'
import type { Element } from 'react'
import React from 'react'
import type { IntlShape } from 'react-intl'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

type Props = {
    name?: string,
    type: string,
    label?: string,
    labelKey?: string,
    labelKeyEnd?: string,
    linkKey?: string,
    openLinkInNewTab?: boolean,
    url?: string,
    checked: boolean,
    children: Element,
    className?: string,
    disabled?: boolean,
    styledSpan?: boolean,
    intl: IntlShape
}

export const CheckOrRadio = ({
    label,
    labelKey,
    labelKeyEnd,
    linkKey = '',
    url,
    className,
    children,
    disabled,
    openLinkInNewTab,
    styledSpan = false,
    ...otherProps
}: Props) => {
    const intl = useIntl()
    return (
        <Label
            className={className}
            disabled={disabled}
            styledSpan={styledSpan}>
            {otherProps.name ? (
                <Field
                    {...otherProps}
                    value={
                        labelKey ? intl.formatMessage({ id: labelKey }) : label
                    }
                    render={() => children}
                />
            ) : (
                children
            )}
            <StyledTextContainer className={className}>
                {label ? (
                    <SmallText>{label}</SmallText>
                ) : (
                    labelKey && (
                        <SmallText>
                            {intl.formatMessage({ id: labelKey })}
                        </SmallText>
                    )
                )}
                {linkKey && url && (
                    <StyledLink
                        url={url}
                        target={openLinkInNewTab ? '_blank' : '_self'}>
                        {intl.formatMessage({ id: linkKey })}
                    </StyledLink>
                )}

                {labelKeyEnd && (
                    <SmallText>
                        {intl.formatMessage({ id: labelKeyEnd })}
                    </SmallText>
                )}
            </StyledTextContainer>
        </Label>
    )
}

const Label = styled.label`
    display: inline-flex;
    cursor: pointer;
    align-items: center;
    ${props =>
        props.disabled &&
        `
        opacity: 0.8;
        cursor: default;
    `};
    input {
        -webkit-appearance: none;
        outline: 0;
        display: none;
    }
    &.agreements {
        align-items: flex-start;
        padding: 0 ${SPACING.XXS};
    }
    &.gift {
        display: flex;
        flex-direction: column;
        text-align: center;
        justify-content: space-between;
        ${media.medium`
            height: 175px;
        `};
    }
    span {
        ${props =>
            props.styledSpan &&
            `
            color: ${COLOR.PRIMARY};
            font-family: ${fonts.flameSansRegular};
        `};
    }
`

const StyledTextContainer = styled.div`
    padding-left: ${SPACING.XXXS};
    &.agreements {
        width: 95%;
        padding-left: ${SPACING.XXS};
        margin-top: ${SPACING.XXXS};
        ${media.medium`margin-top: 0;`}
    }
`

const StyledLink = styled(Link)`
    ${styleSmallText};
    text-decoration: underline;
`
